import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { SecurityMessages } from './security-messages';

type Props = {
  check?: (roles: string[]) => boolean;
  fallback?: ReactElement;
};

export function SecureLayout({ check = () => true, fallback }: Props) {
  const { isAuthenticated, roles } = useAuth();
  const hasPass = check(roles);
  return !isAuthenticated ? (
    <Navigate to='/login' />
  ) : hasPass ? (
    <Outlet />
  ) : (
    fallback || <SecurityMessages.NoAccess />
  );
}
